import { render, staticRenderFns } from "./PaymentForceToSepaModal.vue?vue&type=template&id=1cf5e1ea"
import script from "./PaymentForceToSepaModal.vue?vue&type=script&lang=js"
export * from "./PaymentForceToSepaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports